// extracted by mini-css-extract-plugin
var _1 = "#0078d3";
var _2 = "geotab";
var _3 = "#3c5063";
export { _1 as "mainBlue", _2 as "styleEnvironment", _3 as "tooltipBackgroundColor" }
